import { CatalogModel } from './catalog';
import { PersonFormContactsModel } from './personFormContacts';
import { PersonFormDocumentModel } from './personFormDocument';

export class InitContratantePersona  {

    firstName?: any;
    secondName?: any;
    lastName?: any;
    secondLastName?: any;
    businessName?: any;
    personType: string;
    civilStatus?: CatalogModel;
    birthDate?: any;
    foundContract?: boolean;
    contacts?: PersonFormContactsModel;
    gender?: string;
    constitutionDate?: string;
    document?: PersonFormDocumentModel;
    type = "CONTRACTOR";

    constructor(personType = 'N') {
        this.foundContract = false;
        this.personType = '';
        this.contacts = new PersonFormContactsModel();
        this.document = new PersonFormDocumentModel();
        this.personType = personType;
        if (personType == 'N') {
            this.civilStatus = new CatalogModel();
        }
    }

}